"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Schema = exports.DocNode = exports.ROOT_NAME = exports.ROOT_ID = void 0;
var get_1 = __importDefault(require("lodash/get"));
var set_1 = __importDefault(require("lodash/set"));
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var event_1 = require("../../utils/event");
var jsExpression_1 = require("../../utils/jsExpression");
var compiler = __importStar(require("./compiler"));
exports.ROOT_ID = '__root__';
exports.ROOT_NAME = 'Page';
var getId = (function () {
    var cur = Date.now();
    return function () { return "node_".concat((cur += 1).toString(12)); };
})();
var DocNode = /** @class */ (function () {
    function DocNode(schema, parent) {
        var _this = this;
        /** 相对此node增加节点 */
        this.insertSiblingOrChild = function (newNode, position) {
            // 没有父层说明已经是根节点
            if (!_this.return || position === 'inner') {
                var lastChild = _this.child;
                // eslint-disable-next-line
                newNode.return = _this;
                if (!lastChild) {
                    _this.child = newNode;
                    return;
                }
                while (lastChild.sibling) {
                    lastChild = lastChild.sibling;
                }
                lastChild.sibling = newNode;
                // eslint-disable-next-line
                newNode.left = lastChild;
                return;
            }
            if (position === 'before') {
                _this.setLeftSibling(newNode);
            }
            else if (position === 'after') {
                _this.setSibling(newNode);
            }
        };
        this.remove = function () {
            if (!_this.return)
                return false;
            var left = _this.left;
            var right = _this.sibling;
            if (!left) {
                _this.return.child = right;
            }
            else {
                left.sibling = right;
            }
            if (right)
                right.left = left;
            _this.sibling = undefined;
            _this.left = undefined;
            _this.return = undefined;
            return true;
        };
        this.visit = function (visitor) {
            var _a, _b;
            if (!visitor(_this))
                return;
            if ((_a = _this.child) === null || _a === void 0 ? void 0 : _a.visit(visitor))
                return;
            (_b = _this.sibling) === null || _b === void 0 ? void 0 : _b.visit(visitor);
        };
        this.toJSON = function () {
            if (typeof _this.schema === 'string') {
                return _this.schema;
            }
            var children = [];
            var cur = _this.child;
            while (cur) {
                children.push(cur.toJSON());
                cur = cur.sibling;
            }
            return __assign(__assign({}, _this.schema), { children: children.length ? children : undefined });
        };
        /** 右插入 */
        this.setSibling = function (_newNode) {
            var newNode = _newNode;
            var sibling = _this.sibling;
            _this.sibling = newNode;
            newNode.left = _this;
            newNode.return = _this.return;
            if (!sibling)
                return;
            sibling.left = newNode;
            newNode.sibling = sibling;
        };
        /** 左插入 */
        this.setLeftSibling = function (_newNode) {
            var newNode = _newNode;
            var left = _this.left;
            newNode.sibling = _this;
            newNode.return = _this.return;
            _this.left = newNode;
            if (!left) {
                if (_this.return) {
                    _this.return.child = newNode;
                }
                return;
            }
            left.sibling = newNode;
            newNode.left = left;
        };
        this.schema = schema;
        this.id = schema.id || getId();
        this.schema.id = this.id;
        if (schema.children) {
            this.child = DocNode.getInstance(schema.children, this);
        }
        this.return = parent;
    }
    DocNode.getInstance = function (schema, parent) {
        if (schema === undefined || schema === null)
            return undefined;
        var childrenSchema = schema;
        if (!Array.isArray(childrenSchema)) {
            childrenSchema = [schema];
        }
        var first;
        var child;
        var prev;
        var i = 0;
        while (i < childrenSchema.length) {
            child = new DocNode(childrenSchema[i], parent);
            if (!first)
                first = child;
            i += 1;
            if (prev) {
                prev.sibling = child;
                child.left = prev;
            }
            prev = child;
        }
        return first;
    };
    return DocNode;
}());
exports.DocNode = DocNode;
var Schema = /** @class */ (function (_super) {
    __extends(Schema, _super);
    function Schema() {
        var _this = _super.call(this) || this;
        _this.hooks = {
            remove: new event_1.SyncHook(),
            /** 增加节点时可拦截并修改新节点的内容 */
            add: new event_1.SyncHook(),
            /** 移动节点时可拦截 */
            move: new event_1.SyncHook(),
            /** 修改节点时可拦截并修改新节点的内容 */
            nodeUpdate: new event_1.SyncHook(),
        };
        _this.getCurrent = function () { var _a; return (_a = _this.currentDocTree) === null || _a === void 0 ? void 0 : _a.toJSON(); };
        _this.loadSchema = function (schema, update) {
            if (update === void 0) { update = false; }
            var isUpdate = update || !_this.currentDocTree;
            _this.currentDocTree = new DocNode(schema);
            _this.currentDocTree.id = exports.ROOT_ID;
            _this.currentDocTree.schema.id = exports.ROOT_ID;
            if (isUpdate)
                _this.emit('update', { opt: 'reload', schema: _this.getCurrent() });
        };
        /** 增加节点 */
        _this.appendChild = function (_node, targetId, position, mouseEvent) {
            if (position === void 0) { position = 'after'; }
            var newNode = DocNode.getInstance(__assign({ id: getId() }, _node));
            var targetNode = targetId ? _this.findNode(targetId) : _this.currentDocTree;
            if (!targetNode) {
                console.warn('node has no ancestor');
                return;
            }
            targetNode.insertSiblingOrChild(newNode, position);
            newNode = _this.hooks.add.call(newNode, { position: position, mouseEvent: mouseEvent, targetNode: targetNode });
            _this.emit('update', { opt: 'add', id: newNode.id, schema: _this.getCurrent(), targetNode: newNode });
        };
        /** 复制节点 */
        _this.copyChild = function (id) {
            var targetNode = _this.findNode(id);
            if (!targetNode)
                return;
            var schema = (0, cloneDeep_1.default)(targetNode.schema);
            schema.id = getId();
            var newNode = new DocNode(schema);
            targetNode.insertSiblingOrChild(newNode, 'after');
            _this.emit('update', { opt: 'copy', id: newNode.id, schema: _this.getCurrent(), targetNode: newNode });
        };
        /** 更新单个节点, 不触发全局重绘 */
        _this.updateChildProps = function (payload) {
            var id = payload.id, path = payload.path, newVal = payload.newVal, source = payload.source;
            var node = _this.findNode(id);
            if (!node)
                return;
            var nodeSchema = node.schema;
            var finalNewVal = newVal;
            if (!nodeSchema.props) {
                nodeSchema.props = {};
            }
            if (path) {
                if ((0, isEqual_1.default)((0, get_1.default)(nodeSchema.props, path), newVal))
                    return;
                nodeSchema.props = (0, cloneDeep_1.default)(nodeSchema.props);
                finalNewVal = _this.hooks.nodeUpdate.call(newVal, { id: id, path: path, schema: nodeSchema });
                (0, set_1.default)(nodeSchema.props, path, finalNewVal);
            }
            else {
                if ((0, isEqual_1.default)(nodeSchema.props, newVal))
                    return;
                finalNewVal = _this.hooks.nodeUpdate.call(newVal, { id: id, schema: nodeSchema });
                nodeSchema.props = finalNewVal;
            }
            _this.emit("node.update.".concat(id), [path || '', finalNewVal, nodeSchema.props, source]);
            _this.emit('node.update', { schema: _this.getCurrent(), id: id, node: node.toJSON(), path: path, newVal: finalNewVal, docNode: node, source: source });
            return node;
        };
        /** 移动子节点位置 */
        _this.moveChild = function (id, targetId, relate, mouseEvent) {
            if (id === targetId)
                return;
            var thisNode = _this.findNode(id);
            if (!thisNode)
                return;
            var targetNode = _this.findNode(targetId);
            if (!targetNode)
                return;
            _this.hooks.move.call(thisNode, { targetNode: targetNode, position: relate, mouseEvent: mouseEvent });
            thisNode.remove();
            targetNode.insertSiblingOrChild(thisNode, relate);
            _this.emit('update', { opt: 'move', id: id, otherId: targetNode.id, schema: _this.getCurrent() });
        };
        /** 上/下移节点 */
        _this.moveUp = function (id, direction) {
            var thisNode = _this.findNode(id);
            if (!(thisNode === null || thisNode === void 0 ? void 0 : thisNode.return)) {
                console.warn('node has no ancestor');
                return;
            }
            var isUp = direction === 'up';
            var exchangeTarget = isUp ? thisNode.left : thisNode.sibling;
            if (!exchangeTarget)
                return;
            thisNode.remove();
            exchangeTarget.insertSiblingOrChild(thisNode, isUp ? 'before' : 'after');
            _this.emit('update', { opt: 'moveUp', id: id, otherId: exchangeTarget.id, direction: direction, schema: _this.getCurrent() });
        };
        /** 删除节点 */
        _this.removeChild = function (id) {
            var targetNode = _this.findNode(id);
            if (targetNode === null || targetNode === void 0 ? void 0 : targetNode.remove()) {
                var payload = { opt: 'remove', id: id, schema: _this.getCurrent(), targetNode: targetNode };
                _this.emit('update', payload);
            }
        };
        /** 根据ID查找节点 */
        _this.findNode = function (id, node) {
            if (node === void 0) { node = _this.currentDocTree; }
            var target;
            node === null || node === void 0 ? void 0 : node.visit(function (node) {
                if (node.id === id) {
                    target = node;
                    return false;
                }
                return true;
            });
            return target;
        };
        /** 根据组件名字查找所有节点 */
        _this.findNodesByName = function (componentName, node) {
            if (node === void 0) { node = _this.currentDocTree; }
            var result = [];
            var match = typeof componentName === 'string' ? function (name) { return name === componentName; } : function (name) { return componentName.test(name); };
            node === null || node === void 0 ? void 0 : node.visit(function (node) {
                if (match(node.schema.componentName)) {
                    result.push(node);
                }
                return true;
            });
            return result;
        };
        /** 平铺所有节点 */
        _this.flatAllNode = function (node) {
            if (node === void 0) { node = _this.currentDocTree; }
            return _this.findNodesByName(/(?:)/, node);
        };
        /** compile every props with JSExpression */
        _this.compileJSExpression = function () {
            // console.time('compiling');
            var nodes = _this.flatAllNode();
            var q = [];
            nodes.forEach(function (node) {
                var _a = node.schema.props, props = _a === void 0 ? {} : _a;
                (0, jsExpression_1.visitPropsExpression)(props, function (exp, obj, key, value) {
                    var job = compiler.compile(exp).then(function (code) {
                        // eslint-disable-next-line no-param-reassign
                        obj[key] = __assign(__assign({}, value), { code: code });
                    });
                    q.push(job);
                    return obj;
                });
            });
            return Promise.all(q); // .then(() => console.timeEnd('compiling'));
        };
        _this.event.setMaxListeners(100);
        return _this;
    }
    return Schema;
}(event_1.ReadableEvent));
exports.Schema = Schema;
exports.default = new Schema;
